export const AddOn_Label = {
    key: 'label',
    methodName: 'getLabel',
    resultFilter: () => ({ pass: true }),
    isActive: () => true,
};
//# sourceMappingURL=types.js.map